import React, { Component, Fragment } from "react";
import api from "../../../services/api";
import "./styles.css";
import Pagination from "../../../components/Common/pagination";
import Spinner from "../../../components/Spinner";
class Request extends Component {
  state = {
    load: false,
    companies: {},
    socialName: null,
    cnpj: null,
    businessName: null,
    phone: null,
    CompanyTypeId: null,
    objectOfContract: null,
    email: null,
    address: null,
    number: null,
    complement: null,
    city: null,
    state: null,
    district: null,
    sectors: {},
    companyId: null,
    sectorId: null,
    successSectorToCompany: false,
    errorSectorToCompany: false,
    paginas: 0,
    sectorIdSelected: null,
    contacts: {},
    companyDetail: null,
    companyData: {},
    status: {},
    filterStatus:0,
    page: this.props.match.params.page
  };

  componentDidMount() {
   this.searchCompanies();

   this.searchStatus();
  }

  searchCompanies = async (e, filterCnpj, filterSocial, filterStatus, pos) => {
    const user_sector = localStorage.getItem("SectorId");

    let sectorV = (user_sector !== null) ? user_sector : "";

  
    //NEW PAGINATION (URL)
    const urlParams = new URLSearchParams(window.location.search);
    
    
    let cnpj    = urlParams.get('cnpj') ? `&cnpj=${urlParams.get('cnpj')}` : "";
    let razao   = urlParams.get('socialName') ? `&socialName=${urlParams.get('socialName')}` : "";
    let status  = urlParams.get('CompanyStatusId') ? `&CompanyStatusId=${urlParams.get('CompanyStatusId')}` : "";
    let sector  = `&sector=${sectorV}`;
    let pageUrl = urlParams.get('page');

    //END NEW PAGIANTION (URL)

    document.getElementById("filterCnpj").value = urlParams.get('cnpj');
    document.getElementById("filterSocial").value = urlParams.get('socialName');
    document.getElementById("filterStatus").value = urlParams.get('CompanyStatusId');
    
    if(pageUrl){
      var page =  pageUrl;
    } else if(pos) {
      var page = pos ? pos.target.id : 1;
    } else {
      var page = e ? e.target.id : 1;
    }


    urlParams.append('page', page);
    
    this.setState({ load: true, page, filterStatus:urlParams.get('CompanyStatusId') });

    const response = await api.get(
      `/companies?order_by=id&order_direction=DESC&page=${page}${cnpj}${razao}${status}${sector}`
    );

   
    console.log(`==== FILTROS ==== : ${page}${cnpj}${razao}${status}${sector}`);
    this.setState({
      companies: response.data.rows,
      load: false,
      paginas: response.data.pages
    });
  };

  dataCompany = async e => {
    let dados = this.state.companies.filter(
      item => item.cnpj === e.target.id
    )[0];
    
    this.setState({ companyData: dados });
    if (e.target.title > 0) {
      // this.setState({ companyDetail: e.target.id });
      // window.location.href = `../companies/${e.target.id}`;
      document.getElementById(
        "copanyDetail"
      ).href = `../companies/${e.target.id}`;
      document.getElementById("copanyDetail").click();
    } else {
      this.setState({ companyDetail: null, sectorIdSelected: false });
      document.getElementById("btn-modal-company").click();
      this.setState({
        companyId: dados.id,
        socialName: dados.socialName,
        cnpj: dados.cnpj,
        businessName: dados.businessName,
        phone: dados.phone,
        CompanyTypeId: dados.CompanyType.description,
        address: dados.address,
        number: dados.number,
        complement: dados.complement,
        city: dados.city,
        state: dados.state,
        district: dados.district,
        objectOfContract: dados.objectOfContract,
        sectorIdSelected: dados.SectorId
      });

      const cont = await api.get(`/companies/${dados.id}/contacts`);

      this.setState({
        contacts: cont.data.rows,
        successSectorToCompany: false,
        errorSectorToCompany: false,
        load: false
      });
      await this.searchSectors();
      if (dados.SectorId) {
        document.getElementById("selectSector").value = dados.SectorId;
      } else {
        document.getElementById("selectSector").value = "";
      }
    }
  };

  searchSectors = async () => {
    this.setState({ load: true });
    const response = await api.get(`/sectors?status=1`);
    this.setState({ sectors: response.data.rows, load: false });
  };

  selectSector = e => {
    this.setState({ sectorId: e.target.value });
  };

  submitSectorToCompany = async e => {
    if (this.state.sectorId) {
      this.setState({
        successSectorToCompany: false,
        errorSectorToCompany: false,
        load: true
      });
      await api
        .patch(`/companies/${this.state.companyId}`, {
          SectorId: parseInt(this.state.sectorId),
          CompanyStatusId: 2
        })
        .then(response => {
          if (response.data.updated) {
            this.setState({
              successSectorToCompany: true,
              errorSectorToCompany: false,
              load: false,
              sectorIdSelected: true
            });
            this.searchCompanies();
          } else {
            this.setState({
              successSectorToCompany: false,
              errorSectorToCompany: true,
              load: false
            });
          }
        })
        .catch(error => {
          this.setState({
            successSectorToCompany: false,
            errorSectorToCompany: true,
            load: false
          });
        });
    } else {
      this.setState({
        successSectorToCompany: false,
        errorSectorToCompany: false,
        load: false
      });
    }
  };

  filter = (e) => {
    const user_sector = localStorage.getItem("SectorId");

    let sector = (user_sector !== null) ? user_sector : "";

    let filterCnpj = this.transform(
      document.getElementById("filterCnpj").value
    );
    let filterSocial = document.getElementById("filterSocial").value;
    let filterStatus = document.getElementById("filterStatus").value;

    if(filterStatus == 0) filterStatus = "";

    if(e){
      window.location.href = `/solicitations?order_by=id&order_direction=DESC&page=${e.target.id}&cnpj=${filterCnpj}&socialName=${filterSocial}&CompanyStatusId=${filterStatus}&sector=${sector}`;  
    } else {
      window.location.href = `/solicitations?order_by=id&order_direction=DESC&page=1&cnpj=${filterCnpj}&socialName=${filterSocial}&CompanyStatusId=${filterStatus}&sector=${sector}`;
    }
  };

  filterClear = () => {
    const user_sector = localStorage.getItem("SectorId");
    document.getElementById("filterCnpj").value = "";
    document.getElementById("filterSocial").value = "";
    document.getElementById("filterStatus").value = "";

    let sector = (user_sector !== null) ? user_sector : "";

    window.location.href = `/solicitations?order_by=id&order_direction=DESC&page=1&cnpj=&socialName=&CompanyStatusId=&sector=${sector}`;  
  }; 

  transform = string => {
    var novo = string.replace(/[\-()._/]/g, "");
    return novo;
  };

  searchStatus = async () => {
    this.setState({ load: true });
    const response = await api.get(`/company-status`);
    this.setState({ status: response.data.rows, load: false });
  };

  render() {
    return (
      <Fragment>
        <div className="row page-titles">
          <div className="col-md-12 align-self-center">
            <h3 className="text-themecolor">
              Solicitações
              {/* {this.state.load ? (
                <i className="fa fa-spin fa-spinner"></i>
              ) : null} */}
            </h3>
            <a id="copanyDetail"></a>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <div className="card p-20">
              <div className="row">
                <div className="col-md-3">
                  <label>CNPJ</label>
                  <input
                    type="text"
                    data-mask="99.999.999/9999-99"
                    id="filterCnpj"
                    className="form-control col-12"
                  />
                </div>
                <div className="col-md-3">
                  <label>Status</label>
                  <select id="filterStatus" className="form-control col-12">
                    <option value="0">Todos</option>
                    {this.state.status.length
                      ? this.state.status.map((item, index) => {
                        let selected = (item.id == this.state.filterStatus) ? 'selected' : null; 
                          return (
                            <option key={index} value={item.id} selected={selected}>
                              {item.description}
                            </option>
                          );
                        })
                      : null}
                  </select>
                </div>
                <div className="col-md-6">
                  <label>Razão Social</label>
                  <br />
                  <input
                    type="text"
                    className="form-control col-10"
                    id="filterSocial"
                  />
                  <button className="btn btn-info col-1" id="1" onClick={this.filter}>
                    <i className="fa fa-search"></i>
                  </button>
                  <button
                    className="btn btn-default col-1"
                    id="1"
                    onClick={this.filterClear}
                  >
                    <i id="1" className="fa fa-times"></i>
                  </button>
                </div>
              </div>
            </div>

            <span
              data-toggle="modal"
              data-target=".modal-documents"
              id="btn-modal-company"
            ></span>
            <table className="table table-bordered table-striped">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>CNPJ</th>
                  <th>Razão Social</th>
                  <th>Tipo de Empresa</th>
                  <th>Status</th>
                  <th>Área(s) Gestora(s)</th>
                  <th></th>
                  <th></th>
                  <th></th>
                </tr>
              </thead>
              {!this.state.companies.length ? (
                <Spinner />
              ): null}
              <tbody>
                {this.state.companies.length
                  ? this.state.companies.map((item, index) => {
                      return (
                        <tr key={index}>
                          <td>{item.id}</td>
                          <td>{item.cnpj}<br/><b>Unidade:</b> {item.businessUnit}</td>
                          <td>{item.socialName}</td>
                          <td>{item.CompanyType.description}</td>
                          <td
                            className={
                              item.CompanyStatus.description == "Habilitado"
                                ? "text-success"
                                : item.CompanyStatus.description == "Habilitado com Pendências"
                                ? "text-warning"
                                : item.CompanyStatus.description == "Aguardando Aprovação"
                                ? "text-info"
                                : "text-danger"
                            }
                          >
                            <strong>{item.CompanyStatus.description}</strong>
                          </td>
                          <td>
                            {item.Sectors
                              ? item.Sectors.map((it, idx) => (
                                  <span
                                    className="label m-1 label-info"
                                    id={idx}
                                  >
                                    {it.name}
                                  </span>
                                ))
                              : "Indefinida"}
                          </td>
                          <td>
                            <span
                              id={item.cnpj}
                              title={item.Sectors.length}
                              onClick={this.dataCompany}
                              className="btn btn-rounded btn-outline-info"
                            >
                              <i className="fa fa-files-o"></i> Aprov. /
                              Documentos / Integrações
                            </span>
                          </td>
                          <td>
                            {item.SectorId ? (
                              <h3 className="mdi mdi-check text-success text-center"></h3>
                            ) : null}
                          </td>
                          <td>
                            <a
                              href={"./companies-edit/" + item.id}
                              id={item.cnpj}
                              title={item.SectorId}
                              className="btn btn-rounded btn-outline-info"
                            >
                              <i className="fa fa-edit"></i>
                            </a>
                          </td>
                        </tr>
                      );
                    })
                  : null}
              </tbody>
            </table>
            
          </div>
        </div>

        <Pagination
              function={this.filter}
              paginas={this.state.paginas}
              curPage={this.state.page}
            />

        <div
          className="modal fade modal-documents"
          data-backdrop="static"
          role="dialog"
          aria-labelledby="myLargeModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="myLargeModalLabel">
                  Empresa Detalhes
                  {this.state.load ? (
                    <i className="fa fa-spin fa-spinner"></i>
                  ) : null}
                </h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-hidden="true"
                >
                  ×
                </button>
              </div>
              <div className="modal-body">
                <div className="row">
                  <div className="col-md-6 p-10">
                    <strong className="text-primary p-10">Razão Social:</strong>
                    <span>{this.state.socialName}</span>
                  </div>
                  <div className="col-md-6 p-10">
                    <strong className="text-primary p-10">CNPJ:</strong>
                    <span>{this.state.cnpj}</span>
                  </div>
                  <div className="col-md-6 p-10">
                    <strong className="text-primary p-10">
                      Nome Fantasia:
                    </strong>
                    <span>{this.state.businessName}</span>
                  </div>
                  <div className="col-md-6 p-10">
                    <strong className="text-primary p-10">Telefone:</strong>
                    <span>{this.state.phone}</span>
                  </div>
                  <div className="col-md-6 p-10">
                    <strong className="text-primary p-10">
                      Tipo de Empresa:
                    </strong>
                    <span>{this.state.CompanyTypeId}</span>
                  </div>
                  <div className="col-md-6 p-10">
                    <strong className="text-primary p-10">Endereço:</strong>
                    <span>{this.state.address}</span>
                  </div>
                  <div className="col-md-6 p-10">
                    <strong className="text-primary p-10">Número:</strong>
                    <span>{this.state.number}</span>
                  </div>
                  <div className="col-md-6 p-10">
                    <strong className="text-primary p-10">Complemento:</strong>
                    <span>{this.state.complement}</span>
                  </div>
                  <div className="col-md-5 p-10">
                    <strong className="text-primary p-10">Cidade:</strong>
                    <span>{this.state.city}</span>
                  </div>
                  <div className="col-md-2 p-10">
                    <strong className="text-primary p-10">UF:</strong>
                    <span>{this.state.state}</span>
                  </div>
                  <div className="col-md-5 p-10">
                    <strong className="text-primary p-10">Bairro:</strong>
                    <span>{this.state.district}</span>
                  </div>
                  <div className="col-md-12 p-10">
                    <strong className="text-primary p-10">
                      Objeto de Contrato:
                    </strong>
                    <span>{this.state.objectOfContract}</span>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-12">
                    <table className="table table-striped table-bordered">
                      <thead>
                        <tr>
                          <td colSpan="3" className="text-center">
                            <strong>Contatos</strong>
                          </td>
                        </tr>
                        <tr>
                          <td>Nome</td>
                          <td>Email</td>
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.contacts.length
                          ? this.state.contacts.map((item, index) => {
                              return (
                                <tr key={item.id}>
                                  <td>{item.name}</td>
                                  <td>{item.email}</td>
                                </tr>
                              );
                            })
                          : null}
                      </tbody>
                    </table>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-12">
                    <h5>Vincular Área Gestora</h5>
                    <select
                      className="custom-select col-md-12"
                      id="selectSector"
                      disabled={this.state.sectorIdSelected}
                      onChange={this.selectSector}
                    >
                      <option value="">Todas</option>
                      {this.state.sectors.length
                        ? this.state.sectors.map((item, index) => {
                            return (
                              <option key={index} value={item.id}>
                                {item.name}
                              </option>
                            );
                          })
                        : null}
                    </select>
                    <br />
                    <br />
                  </div>

                  <div className="col-md-12">
                    {this.state.successSectorToCompany ? (
                      <div className="alert alert-success">
                        Empresa aprovada com sucesso!
                      </div>
                    ) : null}

                    {this.state.errorSectorToCompany ? (
                      <div className="alert alert-danger">
                        Erro, tente novamente!
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                {this.state.load ? (
                  <i className="fa fa-spin fa-spinner"></i>
                ) : null}

                {!this.state.sectorIdSelected && !this.state.load ? (
                  <button
                    className="col-md-4 btn waves-effect waves-light btn-rounded btn-success"
                    onClick={this.submitSectorToCompany}
                  >
                    Aprovar e Solicitar Documentos
                  </button>
                ) : null}
                <button
                  type="button"
                  className="col-md-2 btn btn-secondary btn-rounded waves-effect"
                  data-dismiss="modal"
                >
                  Fechar
                </button>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default Request;
